
import { useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { message } from "antd"; // Assuming message is imported from antd
import { LOGIN, UNAUTHORIZED_PATH } from "../Common/Constants";
import { useNavigate } from "react-router-dom";
import { APIConstants } from "../Common/APIConstants";
// import { setMessage } from "./Reducers/FooterReducer";
import { useCache, useCacheDispatch } from "../Common/CacheContext";
import { setMessage } from "../Store/Reducers/FooterReducer";

export const useStoreUpdaterWithAPI = () => {
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cache = useCache();
  const cacheDispatch = useCacheDispatch();

  const handleApiError = (error) => {
    if (error.response?.status === 401) {
      navigate(LOGIN);
      return;
    }
    message.error("An error occurred. Please try again later.");
  };

  const makeRequest = async ({
    type = "",
    url = "",
    body = "",
    token = "",
    action = null,
    mapper = null,
    throwError = false,
    successMessage = "",
    loading = true,
  
    useCache = false,
  }) => {
    if (type === APIConstants.GET) {
      setLoading(loading);
    } else {
      setIsSaving(true);
    }

    const apiKey = type + "~" + url;
    if (useCache) {
      const apiResponseFromCache = cache.get(apiKey);
      if (apiResponseFromCache !== undefined) {
        if (type === APIConstants.GET) {
          setLoading(false);
        } else {
          setIsSaving(false);
        }
        return new Promise((resolve) => {
          if (action != null) {
            dispatch(action(mapper(apiResponseFromCache)));
          }
          resolve(apiResponseFromCache);
        });
      }
    }

    dispatch(setMessage("Please wait while loading data from " + url.replace(APIConstants.API_BASE_URL, "")));

    try {
      const response = await axios({
        method: type,
        url: url,
        data: body,
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
    
      if (successMessage) {
        message.success(successMessage);
      }

      if (action) {
        dispatch(action(mapper ? mapper(response.data) : response.data));
      }

      if (useCache) {
        cacheDispatch({ type: "add", key: apiKey, value: response.data });
      }

      return mapper ? mapper(response.data) : response.data;
    } catch (error) {
      // handleApiError(error);
      if (throwError) {
        throw error;
      }
      return undefined;
    } finally {
      setLoading(false);
      if (type !== APIConstants.GET) {
        setIsSaving(false);
      }
      dispatch(setMessage(""));
    }
  };
  const makeRequest2 = async ({
    type = "",
    url = "",
    body = "",
    token = "",
    action = null,
    mapper = null,
    throwError = false,
    successMessage = "",
    loading = true,
  
    useCache = false,
  }) => {
    if (type === APIConstants.GET) {
      setLoading(loading);
    } else {
      setIsSaving(true);
    }

    const apiKey = type + "~" + url;
    if (useCache) {
      const apiResponseFromCache = cache.get(apiKey);
      if (apiResponseFromCache !== undefined) {
        if (type === APIConstants.GET) {
          setLoading(false);
        } else {
          setIsSaving(false);
        }
        return new Promise((resolve) => {
          if (action != null) {
            dispatch(action(mapper(apiResponseFromCache)));
          }
          resolve(apiResponseFromCache);
        });
      }
    }

    dispatch(setMessage("Please wait while loading data from " + url.replace(APIConstants.API_BASE_URL, "")));

    try {
      const response = await axios({
        method: type,
        url: url,
        data: body,
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      });
    
      if (successMessage) {
        message.success(successMessage);
      }

      if (action) {
        dispatch(action(mapper ? mapper(response.data) : response.data));
      }

      if (useCache) {
        cacheDispatch({ type: "add", key: apiKey, value: response.data });
      }

      return mapper ? mapper(response.data) : response.data;
    } catch (error) {
      // handleApiError(error);
      if (throwError) {
        throw error;
      }
      return undefined;
    } finally {
      setLoading(false);
      if (type !== APIConstants.GET) {
        setIsSaving(false);
      }
      dispatch(setMessage(""));
    }
  };
  // inside useStoreUpdaterWithAPI hook
const validateScreenAccess = async (screenName) => {
  try {
    const response = await makeRequest({
      type: APIConstants.GET, // or POST if API expects body
      url: `${APIConstants.API_BASE_URL}/validateScreen?screenName=${screenName}`, 
      throwError: true,
    });

    // Assuming API response format:
    // { allowed: true } or { allowed: false }
    return response?.allowed === true;
  } catch (error) {
    handleApiError(error);
    return false;
  }
};
function isScreenAllowed(user, screenName) {
  if (!user?.login || !Array.isArray(user.screens)) {
    return false; // not logged in or invalid data
  }

  return user.screens.some(s => s.screenName === screenName);
}

function screenNameChecker(user, targetName) {

  // console.log(user)
  // console.log(targetName )

  return user.some( 
    (screen) =>
      screen.screenName &&
      screen.screenName.trim().toLowerCase() === targetName.trim().toLowerCase()
  );
}




  return { loading, isSaving, makeRequest,validateScreenAccess,screenNameChecker,makeRequest2 };
};
